module.exports = "/images/QcompetitorLogo.png?427b31976c5f37f006c1ebced51be91b";